module.exports = __webpack_public_path__ + "static/people_img12-031457c91ecd5248901d6d7750040336.png";